import React from 'react';
import { processTextContent } from './textUtils';

/**
 * Converts text with \n characters to React elements with line breaks
 * @param text - The text that may contain \n characters
 * @returns React elements with proper line breaks
 */
export const renderTextWithLineBreaks = (text: string): React.ReactNode => {
  if (!text) return '';
  
  return text.split('\n').map((line, index, array) => (
    <React.Fragment key={index}>
      {line}
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));
};

/**
 * Combines processing and rendering of text with line breaks
 * @param text - The raw text that may contain escape sequences and \n
 * @returns React elements with proper formatting
 */
export const renderProcessedText = (text: string): React.ReactNode => {
  const processedText = processTextContent(text);
  return renderTextWithLineBreaks(processedText);
};
